import { Button, TextField, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { useTheme } from "@emotion/react";
import ModalBox from '../../components/ModalBox';
import useAxiosPrivate from '../../hooks/use-axios-private';
import Empty from '../../components/Empty';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import { CircularProgress } from '@mui/material';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { alertMsg } from '../../utils/basicUtils';
import { visuallyHidden } from '@mui/utils';
import { useCallback } from 'react';

const EditorPicker = (props) => {
    const theme = useTheme()
    const [editors, setEditors] = useState(false)
    const axios = useAxiosPrivate()
    const [searchText, setSearchText] = useState("")
    const [ascorder, setAscorder] = useState("desc")
    const [orderByJobs, setOrderByJobs] = useState([])
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [count, setCount] = useState(0);

    const headCells = [
        {
            id: 'id',
            numeric: false,
            disablePadding: true,
            label: 'ID',
        },
        {
            id: 'first_name',
            numeric: false,
            disablePadding: false,
            label: 'Name',
        },
        {
            id: 'job_count',
            numeric: true,
            disablePadding: false,
            label: 'Job Count',
        },
    ];

    const EnhancedTableHead = (props) => {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (newOrderBy) => {
            onRequestSort(newOrderBy);
        };

        return (
            <TableHead>
                <TableRow sx={{ height: 50 }}>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.id === "job_count" ? 'center' : 'left'}
                            sortDirection={orderBy === headCell.id ? order : false}
                            sx={{ whiteSpace: "nowrap" }}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy}
                                onClick={() => createSortHandler(headCell.id)}
                                sx={{ pl: headCell.id === "id" ? 3 : 0 }}
                            >
                                {headCell.label}
                                {orderBy === headCell.id && (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                )
                                }
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }

    EnhancedTableHead.propTypes = {
        onRequestSort: PropTypes.func.isRequired,
        // order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        // orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    const handleChangePage = useCallback(
        (event, newPage) => {
            setPage(newPage)
        },
        []
    );

    const handleChangeRowsPerPage = useCallback(
        (event) => {
            const updatedRowsPerPage = parseInt(event.target.value, 10);
            setRowsPerPage(updatedRowsPerPage);
            setPage(0);
            // There is no layout jump to handle on the first page.
        }, []
    );
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            return;
        }
    };
    const orderChange = (newOrderBy) => {
        if (ascorder === "desc") {
            setAscorder("asc")
            setOrderByJobs(newOrderBy)
        }
        else {
            setAscorder("desc")
            setOrderByJobs(newOrderBy)
        }
    }
    useEffect(() => {
        const getEditorList = async () => {
            try {
                const resp = await axios.get('users/editors/', {
                    params: {
                        limit: rowsPerPage, search: searchText, page: page + 1
                        , order_by: orderByJobs, order_by_type: ascorder,
                    }
                })
                setEditors(resp.data.data.users)
                setCount(resp.data.data.page_info.count)
            } catch (error) {
                console.error("🚀 ~ file: EmployeePicker.jsx:25 ~ getUserList ~ error:", error)
            }
        }
        getEditorList()

    }, [searchText, rowsPerPage, page, orderByJobs, ascorder])

    return (
        <Box>
            <ModalBox open={true}>
                <Box sx={{ color: theme.palette.mode === "dark" ? '#fff' : '#000', maxHeight: "88vh", pr: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                        <Box>
                            <Typography sx={{ fontSize: { xs: "16px", md: "20px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>{props.title ? props.title : "Select User"}</Typography>
                        </Box>
                        <Box onClick={() => props.onClose(false)} sx={{ textAlign: "right", }}>
                            <CloseIcon sx={{
                                fontSize: '26px', border: "0.25px solid tomato", color: "tomato", padding: "2px", borderRadius: "4px", cursor: "pointer", transition: "0.4s",
                                '&:hover': {
                                    background: "#ff4040",
                                    color: "#fff"
                                },
                            }}></CloseIcon>
                        </Box>
                    </Box>
                    <Box>
                        <Box>
                            <Box sx={{ width: "100%", mt: 2 }}>
                                <TextField fullWidth label="Search" variant="standard" size="small" type='search' onChange={(e) => setSearchText(e.target.value)} autoComplete='off' />
                            </Box>
                            <Box sx={{ my: 3 }}>
                                {
                                    !editors ?
                                        <Box sx={{ height: 350, width: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                            <CircularProgress sx={{ color: "primary" }} />
                                        </Box>
                                        : <Box>
                                            {editors.length > 0 ?
                                                <Box>
                                                    <Box className="overflow-scroll" sx={{ width: '100%', height: "395px", overflowY: "auto", pr: 0.4, pl: 0.1 }}>
                                                        <Paper sx={{ width: '100%', mb: 2, }}>
                                                            <TableContainer>
                                                                <Table sx={{ minWidth: 400, }} size={'small'} >
                                                                    <EnhancedTableHead
                                                                        // order={order}
                                                                        // orderBy={orderBy}
                                                                        onSelectAllClick={handleSelectAllClick}
                                                                        onRequestSort={(newOrderBy) => { orderChange(newOrderBy) }}
                                                                        rowCount={editors.length}
                                                                        orderBy={ascorder}
                                                                    />
                                                                    <TableBody>
                                                                        {editors.map((row, index) => {
                                                                            return (
                                                                                <TableRow hover tabIndex={-1} key={index}
                                                                                    onClick={(e) =>
                                                                                        props.setSelectedEditors(prev => {
                                                                                            if (!props.multiple) {
                                                                                                return row.id
                                                                                            }
                                                                                            if (!prev.includes(row.id)) {
                                                                                                prev.push(row.id)
                                                                                            }
                                                                                            else {
                                                                                                let indexValue = props.selectedEditors.indexOf(row.id)
                                                                                                if (indexValue >= 0) {
                                                                                                    prev.splice(indexValue, 1)
                                                                                                }
                                                                                            }
                                                                                            return [...prev]
                                                                                        })
                                                                                    }
                                                                                    role="checkbox"
                                                                                    sx={{ cursor: 'pointer' }}

                                                                                >
                                                                                    <TableCell align="left" >
                                                                                        <Typography sx={{ ml: 1, fontSize: "15px", lineHeight: 1 }} >
                                                                                            <Checkbox
                                                                                                checked={props.multiple ? props.selectedEditors.includes(row.id) : props.selectedEditors === row.id}

                                                                                            />
                                                                                            {row.employee_id}
                                                                                        </Typography>
                                                                                    </TableCell>
                                                                                    <TableCell align="left" sx={{ textTransform: "capitalize" }}>{row.first_name}</TableCell>
                                                                                    <TableCell align="center">{row.job_count}</TableCell>
                                                                                </TableRow>
                                                                            );
                                                                        })
                                                                        }
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>
                                                            <TablePagination
                                                                rowsPerPageOptions={[5, 10, 25]}
                                                                component="div"
                                                                count={count}
                                                                rowsPerPage={rowsPerPage}
                                                                page={page}
                                                                onPageChange={handleChangePage}
                                                                onRowsPerPageChange={handleChangeRowsPerPage}
                                                            />
                                                        </Paper>
                                                    </Box>
                                                    <Box sx={{ textAlign: "center" }}>
                                                        <Button sx={{ minWidth: 80, fontSize: 12, px: 4 }} variant="outlined"
                                                            onClick={(e) => {
                                                                if (e.detail === 1) {
                                                                    props.selectedEditors.length > 0 ? props.onSubmit(props.selectedEditors) : alertMsg("Please select atleast one editor", 'warning')
                                                                }
                                                            }
                                                            }
                                                        >
                                                            {props.reAssign ? "Re-assign" : "Assign"}
                                                        </Button>
                                                    </Box>
                                                </Box>
                                                :
                                                <Empty text="No editors available" icon={<PersonOutlineOutlinedIcon sx={{ color: "text.secondary", fontSize: { xs: 20, md: 30 } }} />} />
                                            }
                                        </Box>
                                }
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </ModalBox>
        </Box >


    )
}

export default EditorPicker


